// extracted by mini-css-extract-plugin
export default {"Container":"ppt_Container__ka4LN","backdrop":"ppt_backdrop__hOBwI"};